import { get, post, patch } from './client.js';

export const login = (email, password) =>
  post('/auth/login', { email, password });

export const register = (email, name, password) =>
  post('/auth/register', { email, name, password });

export const me = () => get('/auth/me');

export const logout = (refreshToken) =>
  post('/auth/logout', { refreshToken });

export const forgotPassword = (email) =>
  post('/auth/forgot-password', { email });

export const resetPassword = (token, newPassword) =>
  post('/auth/reset-password', { token, newPassword });

export const changePassword = (currentPassword, newPassword) =>
  post('/auth/change-password', { currentPassword, newPassword });

export const updateProfile = (body) => patch('/auth/profile', body);
